import { render } from "./NewSubproject.vue?vue&type=template&id=37ad6e99"
import script from "./NewSubproject.vue?vue&type=script&lang=js"
export * from "./NewSubproject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__